import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import contactInquiries from './contact-inquiries'
import phoneVerifications from './phone-verifications'
/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/leads',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::index
* @see app/Http/Controllers/Admin/LeadController.php:25
* @route '/admin/leads'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
export const show = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/leads/{origin}/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
show.url = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            origin: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        origin: args.origin,
        id: args.id,
    }

    return show.definition.url
            .replace('{origin}', parsedArgs.origin.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
show.get = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
show.head = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
const showForm = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
showForm.get = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::show
* @see app/Http/Controllers/Admin/LeadController.php:39
* @route '/admin/leads/{origin}/{id}'
*/
showForm.head = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\LeadController::resend
* @see app/Http/Controllers/Admin/LeadController.php:52
* @route '/admin/leads/{origin}/{id}/resend'
*/
export const resend = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resend.url(args, options),
    method: 'post',
})

resend.definition = {
    methods: ["post"],
    url: '/admin/leads/{origin}/{id}/resend',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\LeadController::resend
* @see app/Http/Controllers/Admin/LeadController.php:52
* @route '/admin/leads/{origin}/{id}/resend'
*/
resend.url = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            origin: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        origin: args.origin,
        id: args.id,
    }

    return resend.definition.url
            .replace('{origin}', parsedArgs.origin.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LeadController::resend
* @see app/Http/Controllers/Admin/LeadController.php:52
* @route '/admin/leads/{origin}/{id}/resend'
*/
resend.post = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::resend
* @see app/Http/Controllers/Admin/LeadController.php:52
* @route '/admin/leads/{origin}/{id}/resend'
*/
const resendForm = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LeadController::resend
* @see app/Http/Controllers/Admin/LeadController.php:52
* @route '/admin/leads/{origin}/{id}/resend'
*/
resendForm.post = (args: { origin: string | number, id: string | number } | [origin: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resend.url(args, options),
    method: 'post',
})

resend.form = resendForm

const leads = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    resend: Object.assign(resend, resend),
    contactInquiries: Object.assign(contactInquiries, contactInquiries),
    phoneVerifications: Object.assign(phoneVerifications, phoneVerifications),
}

export default leads